import { render, staticRenderFns } from "./RTMP.vue?vue&type=template&id=4dc14272&scoped=true"
import script from "./RTMP.vue?vue&type=script&lang=js"
export * from "./RTMP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc14272",
  null
  
)

export default component.exports